import { Divider, InputAdornment } from '@mui/material';
import {
  CcfAvailableIcon,
  CcfBox,
  CcfDeboucedInput,
  CcfDirectoryIcon,
  CcfHeader,
  CcfNotFavoriteIcon,
  CcfSearchIcon,
  CcfSingleArrowIcon,
  CcfTypography,
  CcfTextEditorHeaderPersonIcon,
  CcfButton,
  CcfPhoneIcon,
  CcfCallTransferIcon,
  CcfCallCommitIcon,
} from '@nice-ccf/ui-controls';
import { ConversationsAppFooter } from '../ccf-app-agent-messages/conversations-app-footer/conversations-app-footer';
import { ConversationsReplyAppContainer } from '../ccf-app-agent-messages/conversations-reply-app-container/conversations-reply-app-container';
import styles from './ccf-directory.module.scss';
/* eslint-disable-next-line */
export interface CcfMockDirectoryProps {}

/**
 * Component displays directory static image for demo
 * @param props -CcfMockDirectoryProps
 * @returns directory static image for demo
 * ```
 * @example
 * const inboxCardState = 1
 * <CcfMockDirectory inboxCardState={inboxCardStateVal}
 * ```
 */
export function CcfMockDirectory(props: CcfMockDirectoryProps) {
  const data = [
    { agentName: 'Angus Lindgren', status: 'Available' },
    { agentName: 'Brandy Furness', status: 'Available' },
    { agentName: 'Greg Zapata', status: 'Available' },
    { agentName: 'Harold Hadlock', status: 'Available' },
    { agentName: 'Jenny Andrews', status: 'Available' },
    { agentName: 'Katie Christensen', status: 'Available' },
  ];
  return (
    <CcfBox style={{ width: '100%', border: '1px solid #DEE5EA' }}>
      <div style={{ background: '#F8FAFB', height: '30px' }}>
        <CcfHeader
          LeftIcon={<CcfDirectoryIcon className={styles.directoryIcon} />}
          headerText={'Directory'}
          headerTextClassess={styles.headerText}
          RightIcon
        ></CcfHeader>
      </div>
      <CcfBox className={styles.mockDirectoryDashboard}>
        <CcfBox className={styles.mockDirectoryLeftBlock}>
          <CcfBox className={styles.searchBox}>
            <CcfDeboucedInput
              size="small"
              style={{
                background: 'white',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CcfSearchIcon htmlColor="grey" />
                  </InputAdornment>
                ),
                classes: { adornedStart: styles.searchInputBox },
              }}
              placeholder=""
              variant="outlined"
              fullWidth
              delay={1000}
              classes={{
                root: styles.searchInput,
              }}
            />
          </CcfBox>
          <CcfBox className={styles.customDropdown}>
            {' '}
            <CcfTypography className={styles.txtPeople}>
              People
            </CcfTypography>{' '}
            <CcfSingleArrowIcon className={styles.dropdownIcon} />
          </CcfBox>
          <CcfBox>
            {data.map((agent: any) => {
              return (
                <>
                  <CcfBox className={styles.agentDataBlock}>
                    <CcfTypography className={styles.txtAgentBlock}>
                      {agent.agentName}
                    </CcfTypography>
                    <CcfNotFavoriteIcon />
                  </CcfBox>

                  <CcfBox className={styles.agentStatusBlock}>
                    <CcfAvailableIcon
                      style={{
                        height: '16px',
                        width: '16px',
                        marginRight: '5px',
                      }}
                    />
                    <CcfTypography className={styles.txtStatus}>
                      {agent.status}
                    </CcfTypography>
                  </CcfBox>
                </>
              );
            })}
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.mockDirectoryRightBlock}>
          <CcfBox className={styles.rightBlockHeader}>
            <CcfBox className={styles.rightBlockHeaderLeftSection}>
              <CcfTextEditorHeaderPersonIcon
                style={{
                  height: '18px',
                  width: '18px',
                  marginRight: '10px',
                  marginLeft: '10px',
                }}
              />
              <CcfTypography className={styles.agentHeaderName}>
                Angus Lindgren
              </CcfTypography>
              <CcfTypography className={styles.subTextHeader}>
                | 12 Online
              </CcfTypography>
            </CcfBox>

            <CcfBox
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <CcfButton className={styles.callBtn}>
                <CcfPhoneIcon className={styles.phoneIcon} />
                <CcfTypography className={styles.txtCall}>Call</CcfTypography>
              </CcfButton>
              <CcfButton className={styles.callBtn}>
                <CcfCallTransferIcon viewBox="0 0 25 20" className={styles.phoneIcon} />
                <CcfTypography className={styles.txtCall}>
                  Transfer
                </CcfTypography>
              </CcfButton>
              <CcfButton className={styles.callBtn}>
                <CcfCallCommitIcon className={styles.phoneIcon} />
                <CcfTypography className={styles.txtCall}>
                  Create Commit
                </CcfTypography>
              </CcfButton>
            </CcfBox>
          </CcfBox>
          <div className={styles.chatContainer}>
            <div className={styles.chatBodyContainer}></div>
            <div className={styles.chatBoxContainer}>
              <ConversationsReplyAppContainer />
              <Divider />
              <ConversationsAppFooter />
            </div>
          </div>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}
